import { Bar, mixins } from "vue-chartjs"
import numeral from "numeral"

export default Bar.extend({
    mixins: [mixins.reactiveProp],
    mounted () {
        this.renderChart(this.chartData, this.options)
    },
    /*
    watch: {
        'yMax': "reset"
    },
    methods: {
        reset () {
            if(this._chart) this._chart.destroy()
            this.renderChart(this.chartData, this.options)
        }
    },
    */
    computed: {
        options () {
            return {
                tooltips: {
                    mode: "index",
                    callbacks: {
                        title: (tooltipItems, data) => {
                            let total = 0
                            data.datasets.forEach((dataset) => {
                                total += dataset.data[tooltipItems[0].index]
                            })
                            return `${tooltipItems[0].xLabel}: ${numeral(total).format("0,0")} proposal(s)`
                        },
                        label: function (tooltipItem, data) {
                            return `${data.datasets[tooltipItem.datasetIndex].label}: ${numeral(tooltipItem.value).format("0,0")}`
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            // suggestedMax: this.yMax,
                            fontColor: "#00274F",
                            callback: function (value, index, values) {
                                return `${numeral(value).format("0,0")}`
                            }
                        },
                        gridLines: {
                            display: true,
                            color: "rgba(0, 39, 79, 0.1)"
                        }
                    }],
                    xAxes: [{
                        stacked: true,
                        scaleLabel: {
                            display: true,
                            labelString: "Date when project record was created",
                            fontSize: 10
                        },
                        ticks: {
                            fontSize: 10,
                            fontColor: "#00274F"
                        },
                        gridLines: {
                            display: false,
                            color: "rgba(0, 39, 79, 0.1)"
                        },
                        categoryPercentage: 0.9,
                        barPercentage: 0.8
                    }]
                },
                legend: {
                    display: true,
                    reverse: true,
                    position: "bottom",
                    labels: {
                        fontSize: 11,
                        // fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                        fontStyle: "bold",
                        fontColor: "#00274F",
                        boxWidth: 14,
                        padding: 13
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    props: {
        chartData: {
            type: Array | Object,
            required: false
        },
        yMax: {
            type: Number,
            default: 0
        }
    }
})
